export default __webpack_public_path__ + "static/media/dance.7998dda3.svg";